import React from "react";
import { Box } from "@mui/material";
import { theme } from "../../theme/colors";
import { POST_TYPE_LABELS, POST_TYPE_ICONS } from "../../utils/postTypeConfig";

function formatPostTypeFallback(postType) {
  if (!postType) return "Post";
  return postType
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/** Read-only post type badge for feed and dashboard cards (icon only, matches mobile). */
export default function PostTypeChip({ postType }) {
  if (!postType) return null;

  const label = POST_TYPE_LABELS[postType] || formatPostTypeFallback(postType);
  const icon = POST_TYPE_ICONS[postType];

  if (!icon) return null;

  return (
    <Box
      role="img"
      aria-label={label}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0.75,
        borderRadius: "10px",
        bgcolor: `${theme.primary}15`,
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: "flex", color: theme.primary, "& svg": { fontSize: 18 } }}>
        {icon}
      </Box>
    </Box>
  );
}
